import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { motion } from "framer-motion";
import { LogOut, LayoutDashboard } from "lucide-react";
import XionLogo from "./XionLogo";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <motion.header
      initial={{ y: -32, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className="fixed top-0 inset-x-0 z-50"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10 mt-4">
        <div className="glass-card rounded-2xl px-5 py-3 flex items-center justify-between">
          <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5 group">
            <div className="transition-transform group-hover:scale-110">
              <XionLogo size={28} />
            </div>
            <span className="font-display font-black text-xl tracking-tighter text-[#0E0E1A]">
              XION
            </span>
            <span className="hidden sm:inline-block font-mono text-[10px] uppercase tracking-[0.2em] text-[#00D4FF]/60 ml-1">
              / labs
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-7 text-sm font-medium text-[#4B5563]">
            {[
              { to: "/", label: "Home" },
              { to: "/services", label: "Services" },
              { to: "/portfolio", label: "Work" },
              { to: "/pricing", label: "Pricing" },
            ].map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                data-testid={`nav-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `transition-colors hover:text-[#0E0E1A] ${isActive ? "text-[#0E0E1A]" : "text-[#5A5A72]"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            {user && user !== false ? (
              <>
                <Link
                  to={user.role === "admin" ? "/admin" : "/dashboard"}
                  data-testid="nav-dashboard"
                  className="hidden sm:inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg btn-ghost text-sm"
                >
                  <LayoutDashboard className="w-4 h-4" />
                  {user.role === "admin" ? "Admin" : "Dashboard"}
                </Link>
                <button
                  onClick={handleLogout}
                  data-testid="nav-logout-btn"
                  className="px-3 py-2 rounded-lg btn-ghost text-sm flex items-center gap-1.5"
                >
                  <LogOut className="w-4 h-4" />
                </button>
              </>
            ) : user === false ? (
              <>
                <Link to="/login" data-testid="nav-login" className="hidden sm:inline-flex px-3.5 py-2 rounded-lg btn-ghost text-sm">
                  Sign in
                </Link>
                <Link
                  to="/quote"
                  data-testid="nav-cta-quote"
                  className="px-4 py-2 rounded-lg btn-primary text-sm"
                >
                  Get a Quote
                </Link>
              </>
            ) : null}
          </div>
        </div>
      </div>
    </motion.header>
  );
}
